// frontend/src/config.js
// Centralized configuration for the frontend application

import { API_BASE_URL } from './utils/apiBase';

const config = {
  // API Configuration
  apiBaseUrl: API_BASE_URL,
  
  // App Configuration
  appName: 'FuseSoul',
  appVersion: process.env.REACT_APP_VERSION || '1.0.0',
  
  // Feature Flags
  features: {
    pushNotifications: true,
    offlineSupport: true,
    pwaInstall: true,
    googleOAuth: true,
    weeklyCheckins: true
  },
  
  // UI Configuration
  ui: {
    theme: 'light', // or 'dark'
    language: 'en',
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
  },
  
  // Analytics Configuration
  analytics: {
    enabled: process.env.NODE_ENV === 'production',
    trackingId: process.env.REACT_APP_GA_TRACKING_ID
  },
  
  // PWA Configuration
  pwa: {
    name: 'FuseSoul',
    shortName: 'FuseSoul',
    description: 'Your wellness journey starts here',
    themeColor: '#4F46E5',
    backgroundColor: '#FFFFFF'
  }
};

// Config loaded (no logging)

export default config;
